import { put, call } from "redux-saga/effects";
import { authApi } from "../../../Utils/Constant";
import toast from "react-hot-toast";
import { POST_API } from "../../../Services/API/ApiInstance";
import { postCreateEventfailure, postCreateEventSuccess } from "../../Actions";

function* createEventSaga(body: any): Generator<any, void, any> {
  const data = body.payload;
  delete data.id;

  try {
    const res = yield call(POST_API, authApi.CREATE_EVENTS, data);
    toast.success(res.message);

    yield put(postCreateEventSuccess(res.data));
  } catch (error: any) {
    toast.dismiss();
    toast.error(error?.response?.data?.message);
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      setTimeout(() => {
        window.location.href = "/login";
      }, 1000);
    }
    yield put(postCreateEventfailure(error));
  }
}

export default createEventSaga;
